import React, { useState } from "react";
import {
  Divider,
  Grid,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import SelectCustom from "../Generics/Select";
import SingleItaComponent from "./ClientDataComponent/SingleItaComponent";
import SingleUEComponent from "./ClientDataComponent/SingleUEComponent";
import SingleAbroadComponent from "./ClientDataComponent/SingleAbroadComponent";
import CompanyItaComponent from "./ClientDataComponent/CompanyItaComponent";
import CompanyUEComponent from "./ClientDataComponent/CompanyUEComponent";
import CompanyAbroadComponent from "./ClientDataComponent/CompanyAbroadComponent";
import "../../assets/css/text.css";
import ModalHelper from "../Generics/ModalHelper";
import UploadDocument from "../Generics/UploadDocument";

const ClienteComponent = ({
  handleClientUpdate,
  cliente = {
    status: undefined,
    tipologia: undefined,
    lingua_corrispondenza: undefined,
    segmento_operatività: undefined,
  },
  practice,
  errors,
  uploadFilesClient,
  documentPracticeClient,
  removeFilePracticeClient,
  errorFileLarge,
}) => {
  const handleChange = (name, value) => {
    let updatedClient = { ...practice.cliente };

    if (name === "status") {
      updatedClient = {
        status: value,
        tipologia: updatedClient.tipologia,
        lingua_corrispondenza: "",
        email_principale: "",
        email_fatture: "",
        altri_contatti: "",
        cliente_partnership: "",
        contatti: "",
        codice_fiscale: "",
        nome: "",
        cognome: "",
        comune: "",
        indirizzo: "",
        CAP: "",
        partita_iva: "",
        denominazione_sociale: "",
        accordo_cliente_partner: "",
        SDI: "",
        segmento_operatività: "",
      };
    } else if (name === "tipologia") {
      updatedClient = {
        status: updatedClient.status,
        tipologia: value,
        lingua_corrispondenza: undefined,
        email_principale: "",
        email_fatture: "",
        altri_contatti: "",
        cliente_partnership: "",
        contatti: "",
      };
    } else if (name === "appartiene_gruppo_societario" && !value) {
      updatedClient[name] = value;

      if (name === "appartiene_gruppo_societario" && value !== "Sì") {
        const fieldsToClear = [
          "denominazione_gruppo_holding",
          "capogruppo",
          "gruppo_societa_rilevante",
          "relazione_cliente_gruppo",
          "altre_controparti",
        ];
        fieldsToClear.forEach((f) => (updatedClient[f] = ""));
      }
    } else if (name === "cliente_affiliato_gruppo_societari" && !value) {
      updatedClient[name] = value;

      if (name === "cliente_affiliato_gruppo_societari" && value !== "Sì") {
        const fieldsToClear = [
          "cliente_collegamento_societa",
          "cliente_ruolo",
          "cliente_altro",
        ];
        fieldsToClear.forEach((f) => (updatedClient[f] = ""));
      }
    } else if (name === "cliente_partnership") {
      updatedClient[name] = value;

      if (value !== "Sì") {
        updatedClient["accordo_cliente_partner"] = "";
      }
    } else if (name === "cliente_provenienza") {
      updatedClient[name] = value;

      if (value !== "Sì") {
        updatedClient["cliente_area_provenienza"] = "";
      }
    } else {
      updatedClient[name] = value;

      if (name === "altri_contatti" && value === "No") {
        updatedClient["contatti"] = "";
      }
    }

    const updatedPractice = {
      ...practice,
      cliente: updatedClient,
    };

    handleClientUpdate(updatedPractice);
  };

  const status = [
    { key: "Cliente_LEXIA", label: "Già cliente LEXIA" },
    {
      key: "Nuovo_cliente",
      label: "Nuovo cliente",
    },
  ];

  const tipologia = [
    { key: "Persona_fisica_italiana", label: "Persona fisica italiana" },
    {
      key: "Persona_fisica_altro_paese_UE",
      label: "Persona fisica altro paese UE",
    },
    { key: "Persona_fisica_extra_UE", label: "Persona fisica extra UE" },
    { key: "Persona giuridica italiana", label: "Persona giuridica italiana" },
    {
      key: "Persona_giuridica_altro_paese_UE",
      label: "Persona giuridica altro paese UE",
    },
    { key: "Persona_giuridica_extra_UE", label: "Persona giuridica extra UE" },
  ];

  const lingua_corrispondenza = [
    { key: "Italiano", label: "Italiano" },
    { key: "Inglese", label: "Inglese" },
  ];

  const altri_contatti = [
    { key: "altri_contatti_sì", label: "Sì" },
    { key: "altri_contatti_no", label: "No" },
  ];

  const contatto_principale_CRM = [
    { key: "Sì", label: "Sì" },
    { key: "No", label: "No" },
  ];

  const cliente_partnership = [
    { key: "cliente_partnership_sì", label: "Sì" },
    { key: "cliente_partnership_no", label: "No" },
  ];

  const cliente_area_provenienza = [
    { key: "LEXIA Legal & Tax", label: "LEXIA Legal & Tax" },
    { key: "LEXIA Private", label: "LEXIA Private" },
    { key: "LEXIA Corporate Services", label: "LEXIA Corporate Services" },
    { key: "LEXIA Compliance", label: "LEXIA Compliance" },
  ];

  const segmentiOperativita = [
    "Agricoltura",
    "Assicurativo",
    "Automotive",
    "Bancario",
    "Chimico",
    "Commercio al dettaglio (Retail)",
    "Consulenza",
    "Cosmetica",
    "Distribuzione",
    "Domiciliatario",
    "Editoria",
    "Elettronica",
    "Energia",
    "Farmaceutico",
    "Fintech & Blockchain",
    "Fondi di investimento",
    "Fornitore",
    "Gaming",
    "Healthcare",
    "ICT",
    "Industria",
    "IT",
    "Logistica",
    "Lusso",
    "Marketing",
    "Media",
    "Moda",
    "Oil & Gas",
    "Packaging",
    "Pubblica Amministrazione",
    "Real Estate",
    "Rifiuti",
    "Sanità",
    "Servizi",
    "Servizi Finanziari",
    "Servizi Legali",
    "Sicurezza",
    "Telecomunicazioni",
    "Trasporti",
    "Turismo",
    "Non definito",
  ];

  const aziendePartner = [
    "Euro-Wide Company Formations Limited",
    "Polyglot",
    "Startex",
    "Universal Company Incorporations Ltd",
  ];

  const ruolo = ["Controllata", "Controllante", "Affiliata", "Partecipata"];

  const [modalOpen, setModalOpen] = useState(false);
  const [modalObjectInfo, setModalObjectInfo] = useState({});

  const tooltipContent = {
    email_principale: {
      infoTitle: "E-mail di contatto principale",
      description: (
        <>
          <Typography>
            L’e-mail di contatto principale sarà inserita nel CRM e riceverà i
            Client Alert relativi alla pratica. Per aggiungere altre e-mail da
            inserire nel CRM utilizza il successivo campo “Vuoi aggiungere altri
            contatti”.
          </Typography>
        </>
      ),
    },
    contatti: {
      infoTitle: "Altri contatti",
      description: (
        <>
          <Typography>
            Questi contatti verranno inseriti nel database LEXIA. Per ciascun
            contatto specifica se si tratta di un ulteriore contatto generico o
            di un ulteriore destinatario delle fatture.
          </Typography>
        </>
      ),
    },
    contatto_principale_CRM: {
      infoTitle: "Vuoi aggiungere il contatto principale al CRM?",
      description: (
        <>
          <Typography>
            Se l'e-mail di contatto principale viene inserita nel CRM, il
            cliente riceverà i Client Alert relativi alla practice. Per
            aggiungere altre e-mail al CRM utilizza il successivo campo “Vuoi
            aggiungere altri contatti”.
          </Typography>
        </>
      ),
    },
    appartiene_gruppo_societario: {
      infoTitle: "Il cliente appartiene a un gruppo societario?",
      description: (
        <>
          <Typography>
            Spuntare la casella in caso di appartenenza a un gruppo societario o
            collegamenti significativi (controllo, controllo congiunto,
            partecipazioni rilevanti) per finalità di verifica conflitti.
          </Typography>
        </>
      ),
    },
    cliente_affiliato_gruppo_societari: {
      infoTitle: "Il cliente è affiliato a gruppi societari?",
      description: (
        <>
          <Typography>
            Spuntare la casella in caso di appartenenza a un gruppo societario o
            collegamenti significativi (controllo, controllo congiunto,
            partecipazioni rilevanti) per finalità di verifica conflitti.
          </Typography>
        </>
      ),
    },
    cliente_collegamento_societa: {
      infoTitle: "Società/gruppo con cui il cliente è collegato",
      description: (
        <>
          <Typography>
            Il collegamento si ha tipicamente in caso di cariche o
            partecipazioni.
          </Typography>
        </>
      ),
    },
    cliente_ruolo: {
      infoTitle: "Ruolo",
      description: (
        <>
          <Typography>
            Ad esempio, amministratore, azionista, dirigente.
          </Typography>
        </>
      ),
    },
  };

  // codice per apertura info helper
  const handleModalClick = (objectInfo) => {
    setModalObjectInfo(objectInfo);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalObjectInfo({});
  };

  console.log(practice?.cliente?.status);

  return (
    <>
      <Grid container style={{ display: "flex", justifyContent: "center" }}>
        <Grid
          item
          xs={11}
          sm={10}
          style={{ overflowY: "auto", marginTop: "30px" }}
        >
          {/* Title */}
          <Grid
            xs={12}
            spacing={4}
            item
            container
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid item xs={11} md={4}>
              <Typography className="color-blue-dark title-step">
                Cliente
              </Typography>
            </Grid>

            <Grid item xs={11} md={4} style={{ paddingTop: "0px" }}></Grid>

            <Grid item xs={11} md={4} style={{ paddingTop: "0px" }}></Grid>
          </Grid>

          <Grid
            xs={12}
            spacing={4}
            item
            container
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              marginBottom: "100px",
              marginTop: "0px",
            }}
          >
            <Grid item xs={11} md={4}>
              <Typography className="color-blue-dark title-input">
                Status
              </Typography>

              <Select
                value={practice?.cliente?.status || ""}
                error={errors.includes("status")}
                onChange={(e) => handleChange("status", e.target.value)}
                displayEmpty
                fullWidth
                style={{ marginTop: "10px" }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {status.map((item, index) => (
                  <MenuItem key={index} value={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={11} md={4}>
              <Typography className="color-blue-dark title-input">
                Tipologia
              </Typography>

              <Select
                value={practice?.cliente?.tipologia || ""}
                error={errors.includes("tipologia")}
                onChange={(e) => handleChange("tipologia", e.target.value)}
                displayEmpty
                fullWidth
                style={{ marginTop: "10px" }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {tipologia.map((item, index) => (
                  <MenuItem key={index} value={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {practice?.cliente?.status ? (
              practice?.cliente?.status === "Nuovo cliente" ? (
                <>
                  <Grid item xs={11} md={4}>
                    <Typography
                      className="color-blue-dark"
                      style={{ fontSize: "14px" }}
                    >
                      Segmento di operatività
                    </Typography>
                    <Select
                      value={practice?.cliente?.segmento_operatività || ""}
                      error={errors.includes("segmento_operatività")}
                      onChange={(e) =>
                        handleChange("segmento_operatività", e.target.value)
                      }
                      displayEmpty
                      fullWidth
                      style={{ marginTop: "10px" }}
                    >
                      <MenuItem value="">
                        <span style={{ color: "#abb0b6" }}>Seleziona</span>
                      </MenuItem>
                      {segmentiOperativita.map((option, index) => (
                        <MenuItem key={index} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={11} md={4}>
                    <Typography
                      className="color-blue-dark"
                      style={{ fontSize: "14px" }}
                    >
                      Lingua di corrispondenza
                    </Typography>

                    <Select
                      value={practice?.cliente?.lingua_corrispondenza || ""}
                      error={errors.includes("lingua_corrispondenza")}
                      onChange={(e) =>
                        handleChange("lingua_corrispondenza", e.target.value)
                      }
                      displayEmpty
                      fullWidth
                      style={{ marginTop: "10px" }}
                    >
                      <MenuItem value="">
                        <span style={{ color: "#abb0b6" }}>Seleziona</span>
                      </MenuItem>
                      {lingua_corrispondenza.map((item, index) => (
                        <MenuItem key={index} value={item.label}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </>
              ) : null
            ) : null}

            {practice?.cliente?.tipologia && (
              <Grid xs={11} md={12} item style={{ paddingTop: "0px" }}>
                <Divider className="divider" />
              </Grid>
            )}

            {practice?.cliente?.tipologia === "Persona fisica italiana" ? (
              <>
                <SingleItaComponent
                  handleModalClick={handleModalClick}
                  tooltipContent={tooltipContent}
                  ruolo={ruolo}
                  errors={errors}
                  practice={practice}
                  {...cliente}
                  onChange={handleChange}
                />
              </>
            ) : practice?.cliente?.tipologia ===
              "Persona fisica altro paese UE" ? (
              <SingleUEComponent
                handleModalClick={handleModalClick}
                tooltipContent={tooltipContent}
                errors={errors}
                practice={practice}
                {...cliente}
                onChange={handleChange}
              />
            ) : practice?.cliente?.tipologia === "Persona fisica extra UE" ? (
              <SingleAbroadComponent
                handleModalClick={handleModalClick}
                tooltipContent={tooltipContent}
                errors={errors}
                practice={practice}
                {...cliente}
                onChange={handleChange}
              />
            ) : practice?.cliente?.tipologia ===
              "Persona giuridica italiana" ? (
              <CompanyItaComponent
                handleModalClick={handleModalClick}
                tooltipContent={tooltipContent}
                ruolo={ruolo}
                errors={errors}
                practice={practice}
                {...cliente}
                onChange={handleChange}
              />
            ) : practice?.cliente?.tipologia ===
              "Persona giuridica altro paese UE" ? (
              <CompanyUEComponent
                handleModalClick={handleModalClick}
                tooltipContent={tooltipContent}
                ruolo={ruolo}
                practice={practice}
                errors={errors}
                {...cliente}
                onChange={handleChange}
              />
            ) : practice?.cliente?.tipologia ===
              "Persona giuridica extra UE" ? (
              <CompanyAbroadComponent
                handleModalClick={handleModalClick}
                tooltipContent={tooltipContent}
                ruolo={ruolo}
                practice={practice}
                errors={errors}
                {...cliente}
                onChange={handleChange}
              />
            ) : null}

            {practice?.cliente?.status &&
            practice?.cliente?.tipologia &&
            practice?.cliente?.status === "Già cliente LEXIA" ? (
              <>
                <Grid xs={11} md={12} item style={{ paddingTop: "0px" }}>
                  <Divider className="divider" />
                </Grid>

                <Grid item xs={11} md={4}>
                  <Typography className="color-blue-dark title-input">
                    Il cliente proviene da un'altra area LEXIA (cross selling)?
                  </Typography>

                  <Select
                    value={practice?.cliente?.cliente_provenienza || ""}
                    error={errors.includes("cliente_provenienza")}
                    onChange={(e) =>
                      handleChange("cliente_provenienza", e.target.value)
                    }
                    displayEmpty
                    fullWidth
                    style={{ marginTop: "10px" }}
                  >
                    <MenuItem value="">
                      <span style={{ color: "#abb0b6" }}>Seleziona</span>
                    </MenuItem>

                    <MenuItem value="Sì">Sì</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </Grid>

                {practice?.cliente?.cliente_provenienza === "Sì" && (
                  <Grid item xs={11} md={4}>
                    <Typography className="color-blue-dark title-input">
                      Area
                    </Typography>

                    <Select
                      value={practice?.cliente?.cliente_area_provenienza || ""}
                      error={errors.includes("cliente_area_provenienza")}
                      onChange={(e) =>
                        handleChange("cliente_area_provenienza", e.target.value)
                      }
                      displayEmpty
                      fullWidth
                      style={{ marginTop: "10px" }}
                    >
                      <MenuItem value="">
                        <span style={{ color: "#abb0b6" }}>Seleziona</span>
                      </MenuItem>
                      {cliente_area_provenienza.map((item, index) => (
                        <MenuItem key={index} value={item.label}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                )}
              </>
            ) : null}

            {practice?.cliente?.tipologia &&
              practice?.cliente?.status === "Nuovo cliente" && (
                <>
                  <Grid
                    container
                    xs={12}
                    item
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Grid
                      xs={11}
                      md={12}
                      item
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                      }}
                    >
                      {" "}
                      <UploadDocument
                        documentPractice={documentPracticeClient}
                        removeFilePractice={removeFilePracticeClient}
                        uploadFiles={uploadFilesClient}
                        errorFileLarge={errorFileLarge}
                        title="Documenti relativi al cliente (facoltativi)"
                      />
                    </Grid>
                  </Grid>

                  <Grid xs={11} md={12} item style={{ paddingTop: "0px" }}>
                    <Divider className="divider" />
                  </Grid>
                </>
              )}

            {practice?.cliente?.tipologia &&
              practice?.cliente?.status === "Nuovo cliente" && (
                <>
                  <Grid item xs={11} md={4}>
                    <div
                      style={{
                        display: "flex",
                        height: "20px",
                      }}
                    >
                      <Typography className="color-blue-dark title-input">
                        E-mail di contatto principale
                      </Typography>
                      {/* <div
                        className="icon-modal-info"
                        style={{ marginLeft: "10px", cursor: "pointer" }}
                        onClick={() =>
                          handleModalClick(tooltipContent.email_principale)
                        }
                      /> */}
                    </div>
                    <TextField
                      style={{ marginTop: "10px" }}
                      placeholder="Inserisci"
                      variant="outlined"
                      value={practice?.cliente?.email_principale}
                      error={errors.includes("email_principale")}
                      onChange={(e) =>
                        handleChange("email_principale", e.target.value)
                      }
                      fullWidth
                      InputProps={{ style: { color: "#1b2838" } }}
                    />
                  </Grid>

                  <Grid item xs={11} md={4}>
                    <div
                      style={{
                        display: "flex",
                        height: "20px",
                      }}
                    >
                      <Typography className="color-blue-dark title-input">
                        Vuoi aggiungere il contatto principale al CRM?
                      </Typography>
                      <div
                        className="icon-modal-info"
                        style={{ marginLeft: "10px", cursor: "pointer" }}
                        onClick={() =>
                          handleModalClick(
                            tooltipContent.contatto_principale_CRM,
                          )
                        }
                      />
                    </div>

                    <Select
                      value={practice?.cliente?.contatto_principale_CRM || ""}
                      onChange={(e) =>
                        handleChange("contatto_principale_CRM", e.target.value)
                      }
                      error={errors.includes("contatto_principale_CRM")}
                      displayEmpty
                      fullWidth
                      style={{ marginTop: "10px" }}
                    >
                      <MenuItem value="">
                        <span style={{ color: "#abb0b6" }}>Seleziona</span>
                      </MenuItem>
                      {contatto_principale_CRM.map((item, index) => (
                        <MenuItem key={index} value={item.label}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={11} md={4}>
                    <Typography className="color-blue-dark title-input">
                      E-mail di destinazione delle fatture
                    </Typography>
                    <TextField
                      style={{ marginTop: "10px" }}
                      placeholder="Inserisci"
                      variant="outlined"
                      value={practice?.cliente?.email_fatture}
                      error={errors.includes("email_fatture")}
                      onChange={(e) =>
                        handleChange("email_fatture", e.target.value)
                      }
                      fullWidth
                      InputProps={{ style: { color: "#1b2838" } }}
                    />
                  </Grid>

                  <Grid item xs={11} md={4}>
                    <Typography className="color-blue-dark title-input">
                      Vuoi aggiungere altri contatti?
                    </Typography>

                    <Select
                      value={practice?.cliente?.altri_contatti || ""}
                      onChange={(e) =>
                        handleChange("altri_contatti", e.target.value)
                      }
                      error={errors.includes("altri_contatti")}
                      displayEmpty
                      fullWidth
                      style={{ marginTop: "10px" }}
                    >
                      <MenuItem value="">
                        <span style={{ color: "#abb0b6" }}>Seleziona</span>
                      </MenuItem>
                      {altri_contatti.map((item, index) => (
                        <MenuItem key={index} value={item.label}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  {practice?.cliente?.altri_contatti === "Sì" && (
                    <Grid item xs={11} md={4}>
                      <div
                        style={{
                          display: "flex",
                          height: "20px",
                        }}
                      >
                        <Typography className="color-blue-dark title-input">
                          Altri contatti
                        </Typography>
                        <div
                          className="icon-modal-info"
                          style={{ marginLeft: "10px", cursor: "pointer" }}
                          onClick={() =>
                            handleModalClick(tooltipContent.contatti)
                          }
                        />
                      </div>

                      <TextField
                        value={practice?.cliente?.contatti}
                        error={errors.includes("contatti")}
                        multiline
                        rows={5}
                        style={{ marginTop: "10px" }}
                        placeholder="Altri contatti"
                        variant="outlined"
                        onChange={(e) =>
                          handleChange("contatti", e.target.value)
                        }
                        fullWidth
                        InputProps={{ style: { color: "#1b2838" } }}
                      />
                    </Grid>
                  )}

                  <Grid xs={11} md={12} item style={{ paddingTop: "0px" }}>
                    <Divider className="divider" />
                  </Grid>

                  <Grid item xs={11} md={4}>
                    <Typography className="color-blue-dark title-input">
                      Il cliente è segnalato sulla base di una partnership con
                      LEXIA?
                    </Typography>
                    <Select
                      value={practice?.cliente?.cliente_partnership || ""}
                      error={errors.includes("cliente_partnership")}
                      onChange={(e) =>
                        handleChange("cliente_partnership", e.target.value)
                      }
                      displayEmpty
                      fullWidth
                      style={{ marginTop: "10px" }}
                    >
                      <MenuItem value="">
                        <span style={{ color: "#abb0b6" }}>Seleziona</span>
                      </MenuItem>
                      {cliente_partnership.map((item, index) => (
                        <MenuItem key={index} value={item.label}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  {practice?.cliente?.cliente_partnership === "Sì" && (
                    <Grid item xs={11} md={4}>
                      <Typography className="color-blue-dark title-input">
                        Accordo sottostante
                      </Typography>
                      <Select
                        value={practice?.cliente?.accordo_cliente_partner || ""}
                        onChange={(e) =>
                          handleChange(
                            "accordo_cliente_partner",
                            e.target.value,
                          )
                        }
                        error={errors.includes("accordo_cliente_partner")}
                        displayEmpty
                        fullWidth
                        style={{ marginTop: "10px" }}
                      >
                        <MenuItem value="">
                          <span style={{ color: "#abb0b6" }}>Seleziona</span>
                        </MenuItem>
                        {aziendePartner.map((option, index) => (
                          <MenuItem key={index} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  )}
                </>
              )}
          </Grid>
        </Grid>
      </Grid>

      <Modal open={modalOpen} onClose={handleCloseModal}>
        <div>
          <ModalHelper
            onClose={handleCloseModal}
            modalObjectInfo={modalObjectInfo}
          />
        </div>
      </Modal>
    </>
  );
};

export default ClienteComponent;
